import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
import { getCampaignColors } from "./normalizeCampaigns";
/** Card variant (ModernCard, HorizontalCarCard) — spacing/size matches ModernCardTags.tsx. */
var CardCampaignLabel = function CardCampaignLabel(_ref) {
  var data = _ref.data,
    type = _ref.type;
  var isFinance = type === "finance";
  var _getCampaignColors = getCampaignColors(data, type),
    bgColor = _getCampaignColors.bgColor,
    txtColor = _getCampaignColors.txtColor;
  return /*#__PURE__*/React.createElement("div", {
    className: twMerge("flex items-center justify-start gap-1 min-w-0 min-h-[20px] overflow-hidden rounded-[28px] py-0.5 e-2", isFinance && "border border-solid border-[#d9e1eb] py-0"),
    style: {
      backgroundColor: bgColor,
      color: txtColor
    }
  }, data.icon ? /*#__PURE__*/React.createElement("img", {
    src: data.icon,
    alt: "",
    className: "shrink-0 object-contain w-4 h-4 ms-2"
  }) : '', /*#__PURE__*/React.createElement("span", {
    className: "text-[10px] font-medium whitespace-nowrap overflow-hidden text-ellipsis min-w-0 py-0.5",
    dir: "auto"
  }, data.text));
};
export default CardCampaignLabel;